import React from 'react';
import {
    instructorLabel,
    instructorOf,
    submitterIfDifferent,
} from '@/features/programs/coordinatorColumns';

/**
 * The people on a support request: the instructor of record, and under it,
 * in small muted text, who submitted it when that is someone else. The table
 * adds the instructor's address; the phone card leaves it out.
 */
function FacultyCell({ app, showEmail = false }) {
    const instructor = instructorOf(app);
    const submitter = submitterIfDifferent(app);
    return (
        <>
            <strong>{instructorLabel(app)}</strong>
            {showEmail && instructor.email && (
                <small className="text-muted d-none d-md-block">
                    {instructor.email}
                </small>
            )}
            {submitter && (
                <small className="text-muted d-block">
                    Submitted by {submitter.name}
                </small>
            )}
        </>
    );
}

export default FacultyCell;
